module.exports = __webpack_public_path__ + "static/img/RACKPACK.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RACKPACK.png
// module id = n9Na
// module chunks = 0